import {
  formatDelay,
  formatPercentage,
  formatCurrency,
} from "@shared/helpers";

import type { TaxDiffFormatter, TaxDiffPrimitive } from "../../../../helpers";

type Translator = (key: string) => string;
type DiffValuePrimitive = string | number;
type DiffValueFormatter = (value: DiffValuePrimitive, t: Translator) => string;

const RATE_TYPE_LABEL_KEY: Record<string, string> = {
  PERCENTAGE: "payfac.pageRatePlanDetailsPercentage",
  FIXED: "payfac.pageRatePlanDetailsFixed",
};

const RECEIPT_TYPE_LABEL_KEY: Record<string, string> = {
  TIMELINE: "payfac.pageRatePlanDetailsTimeline",
  EARLY: "payfac.pageRatePlanDetailsEarly",
};

const FORMATTERS: Record<TaxDiffFormatter, DiffValueFormatter> = {
  delay: (value) => formatDelay(Number(value)),
  percentage: (value) => formatPercentage(Number(value)),
  currency: (value) => formatCurrency(Number(value)),
  rateType: (value, t) =>
    t(RATE_TYPE_LABEL_KEY[String(value)] ?? String(value)),
  receiptType: (value, t) =>
    t(RECEIPT_TYPE_LABEL_KEY[String(value)] ?? String(value)),
  text: String,
};

export const formatDiffValue = (
  value: TaxDiffPrimitive,
  formatter: TaxDiffFormatter,
  t: Translator,
): string => {
  if (value == null) return "-";

  const handler = FORMATTERS[formatter] ?? FORMATTERS.text;

  return handler(value, t);
};

export const getDiffDirection = (
  oldValue: TaxDiffPrimitive,
  newValue: TaxDiffPrimitive,
): boolean | null => {
  const oldNumeric = +oldValue;
  const newNumeric = +newValue;

  if (
    Number.isNaN(oldNumeric) ||
    Number.isNaN(newNumeric) ||
    newNumeric === oldNumeric
  ) {
    return null;
  }

  return newNumeric > oldNumeric;
};
